import {AfterViewInit, Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {language} from '../../../../language/vn';
import {HoSoService} from '../../../../service/hoso/service-hoso';
import {FormGroup, FormControl, FormBuilder, Validators} from '@angular/forms';
import {HoSo} from '../../../../models/hoso/hoso';
import { ToastrService } from 'ngx-toastr';
import {first} from 'rxjs/operators';
import {validateEmpty} from '../../../../global/custom-validate';
import {BsModalService, ModalDirective} from 'ngx-bootstrap/modal';
import {ConfirmDialogComponent} from '../../../dialog/confirmdialog.component';
import {environment} from '../../../../../environments/environment';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-decoupled-document';
import {HoSoFileService} from '../../../../service/hoso/service-hosofile';
import {HoSoFile} from '../../../../models/hoso/hosofile';
import {UploadFileComponent} from '../../../ui/upload/uploadfile.component';
import {EditKeHoachComponent} from '../../kehoach/edit.component';
import {EditHoSoCaNhanComponent} from './edit.component';
import {Sessioncommand} from '../../../../global/sessioncommand';
import {CommandUtil} from '../../../../global/commandutil';
import {SelectFolderComponent} from '../../folder/select.component';
import {ShareHoSoComponent} from './share.component';
import {GroupSelectComponent} from '../../group/groupselect.component';
import {DetailHoSoComponent} from './detail.component';
import {XuLyHoSoComponent} from '../xuly/hosoxuly.component';

@Component({
  selector: 'app-views-info-hosocanhan',
  templateUrl: './canhan.component.html',
  encapsulation: ViewEncapsulation.None
})
export class HoSoCaNhanComponent implements OnInit, AfterViewInit {
  @ViewChild('largeModal')
  public largeModal: ModalDirective;
  @ViewChild(UploadFileComponent)
  public uploadFileComponent: UploadFileComponent;
  public language = language;
  public totalItems: number = 0;
  public hoSoId:  number;
  public currentPage: number   = environment.currentPage;
  public maxSize: number = environment.pageMaxRecord;
  public numPages: number = environment.numberPages;
  public dataList: HoSo[];
  public status: number[]= [
    environment.hosocanhan
  ];
  public srTuKhoa: string = '';
  constructor( public hosoService: HoSoService,
               public formBuilder: FormBuilder,
               public toastr: ToastrService,
               public bsModalService: BsModalService,
               public commandUtil: CommandUtil
  ) {
  }
  ngAfterViewInit() {

  }
  ngOnInit(): void {
    this.search();
  }
  public showConfirmationModal(id: number): void {
    const modal = this.bsModalService.show(ConfirmDialogComponent);
    (<ConfirmDialogComponent>modal.content).showConfirmationModal(
      language.message,
      language.confirm_delete_question,
      language.yes,
      language.no
    );
    (<ConfirmDialogComponent>modal.content).onClose.subscribe(result => {
      if (result === true) {
        this.deleteItem(id);
      }
    });
  }
  edit(id: number) {
    const modalEdit = this.bsModalService.show(EditHoSoCaNhanComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
    (<EditHoSoCaNhanComponent>modalEdit.content).edit(
      id
    );
    (<EditHoSoCaNhanComponent>modalEdit.content).onClose.subscribe(result => {
      if (result === true) {
        this.search();
      }
    });
  }
  saveFolder(id: number) {
    const modalEdit = this.bsModalService.show(SelectFolderComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
    (<SelectFolderComponent>modalEdit.content).edit(
      id
    );
    (<SelectFolderComponent>modalEdit.content).onClose.subscribe(result => {
      if (result === true) {

      }
    });
  }
  detail(id: number) {
    const modalEdit = this.bsModalService.show(DetailHoSoComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
    (<DetailHoSoComponent>modalEdit.content).edit(
      id
    );
    (<DetailHoSoComponent>modalEdit.content).onClose.subscribe(result => {
      if (result === true) {
        this.search();
      }
    });
  }
  xuLy(id: number) {
    const modalEdit = this.bsModalService.show(XuLyHoSoComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
    (<XuLyHoSoComponent>modalEdit.content).edit(
      id
    );
    (<XuLyHoSoComponent>modalEdit.content).onClose.subscribe(result => {
      if (result === true) {
        this.search();

      }
    });

  }
  selectSave(id: number) {
    const modalEdit = this.bsModalService.show(ShareHoSoComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
    (<ShareHoSoComponent>modalEdit.content).edit(
      id
    );
    (<ShareHoSoComponent>modalEdit.content).onClose.subscribe(result => {
      if (result === true) {

      }
    });
  }
  public search()
  {
    this.hosoService.findAllByPaging(this.srTuKhoa, this.status.join(), Sessioncommand.staffId, this.currentPage, this.maxSize).subscribe(dataList => this.dataList = dataList);
    this.hosoService.getCountByKeyword(this.srTuKhoa, this.status.join(), Sessioncommand.staffId).subscribe(recordCount => this.totalItems = recordCount);
  }


  deleteItem(id: number)
  {
    this.hosoService.delete(id).subscribe({
      next: () => {
        this.toastr.success(language.delete_success_record, language.message);
        this.search();


      },
      error: error => {
        this.toastr.error(language.error, language.message);
      }
    });
  }

  pageChanged(event: any): void {
    this.currentPage = event.page;
    this.search();

  }

}
